export default __webpack_public_path__ + "assets/front/scss/collaborative-indexation.4f5de3f50be08d16e5a7dc2a809f239b.css";